export function parseDate(
    set: React.Dispatch<React.SetStateAction<Date | undefined>>,
    value: string
  ) {
    let dateNumbers: string[] | number[] = value.split("-");
    dateNumbers = dateNumbers.map((num) => {
      return Number(num);
    });
    set(new Date(dateNumbers[0], dateNumbers[1] - 1, dateNumbers[2]));
  }